var map = {
	"./IPRMainPage.PNG": 443,
	"./arrow-down.svg": 546,
	"./bell.svg": 547,
	"./default-avatar.svg": 267,
	"./default-user.svg": 347,
	"./lines.png": 444,
	"./my-team-person-logo.jpg": 445,
	"./no-image.svg": 548,
	"./tdc_logo.png": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 545;